import { FC, ReactNode, createContext, useContext, useMemo } from "react";

import type { PopupImportSourceOption } from "./popupImportSourceOptions";

type Ctx = {
  sourceOptions: PopupImportSourceOption[];
};

const PopupImportSourceOptionsContext = createContext<Ctx | null>(null);

export const PopupImportSourceOptionsProvider: FC<{
  sourceOptions: PopupImportSourceOption[];
  children: ReactNode;
}> = ({ sourceOptions, children }) => {
  const value = useMemo(() => ({ sourceOptions }), [sourceOptions]);
  return (
    <PopupImportSourceOptionsContext.Provider value={value}>
      {children}
    </PopupImportSourceOptionsContext.Provider>
  );
};

export function usePopupImportSourceOptions(): Ctx {
  const v = useContext(PopupImportSourceOptionsContext);
  if (!v) {
    throw new Error(
      "usePopupImportSourceOptions must be used within PopupImportSourceOptionsProvider"
    );
  }
  return v;
}
